import React from "react";
import { useState, useRef } from "react";
import moment from "moment";
import {
  // Card,
  Input,
  Select,
  Form,
  Button,
  Radio,
  Col,
  Row,
  Checkbox,
  DatePicker,
  Tooltip,
  Upload,
  InputNumber,
} from "antd";

import SignatureCanvas from "react-signature-canvas";
import CustomCard from "../../../../globals/components/Card";
import Editor from "../../../Template/Edit/Editor";
import { templateValueonChange } from "../../content.slice";
import { useDispatch } from "react-redux";
import { InfoCircleOutlined, UploadOutlined } from "@ant-design/icons";
import "./previewsamplecontract.less";
const { Option } = Select;
const { TextArea } = Input;
const formItemLayout = {
  labelCol: { xs: 24, sm: 24, md: 24, lg: 8 },
  wrapperCol: { xs: 24, sm: 24, md: 24, lg: 16 },
};

const TemplateData = (props) => {
  const {
    intl: { formatMessage },
    form,
    content,
    local: { _locale },
  } = props;
  const {
    contentFillData,
    contentPreviewRecord,
    contentPreviewModaType = "",
  } = content;
  const dispatch = useDispatch();
  const canvasRef = useRef(null);
  const [content1, setContent] = useState("");

  const selectexpirydata = [
    {
      name: "years",
      value: 1,
    },
    {
      name: "months",
      value: 2,
    },
    {
      name: "days",
      value: 3,
    },
  ];

  // contentFeild
  let foundFeilds = contentPreviewRecord?.contentFeild || [];
  const validateNumber = (rule, value) => {
    if (value >= 1) {
      return Promise.resolve();
    }
    return Promise.reject("Digit must be greater than 0");
  };
  const parentindex=0
  console.log(contentFillData,"jkl")
  return (
    <CustomCard
      title={formatMessage({ id: "Template_details" })}
      headStyle={{ background: "#EBEDEF" }}
      // bordered
      bodyStyle={{ background: "#F5F5F5" }}
    >
      
          <CustomCard
            // bordered
            style={{
              marginTop: 16,
              // padding:"5px",
              // marginLeft:"8px"
            }}
            // headStyle={{ background: "#EBEDEF" }}

            title={"Preview"}
          >
            {contentFillData
              ?.filter((eve) =>
                foundFeilds.includes(eve.field_label || eve.label)
              )
              .map((field, childindex) => (
                <Row className="preview_content" key={childindex}>
                  <Col span={22}>
                    {field.dataType === 13 ? (
                      <>
                        <Form.Item
                          {...formItemLayout}
                          name="contractexpirynumber"
                          style={{ width: "100%" }}
                          initialValue={
                            contentPreviewModaType === "createfromcontent" &&
                            field?.value
                          }
                          rules={[
                            {
                              required: true,
                              message: "Please add Contract expiry",
                            },
                          ]}
                          label={`${
                            field?.translation?.[_locale]?.label ||
                            field?.translation?.en?.label ||
                            field.label
                          }`}
                        >
                          <Form.Item
                            // initialValue={field?.value}
                            name="contractexpirynumber"
                            rules={[
                              { validator: validateNumber },
                              {
                                message: formatMessage({ id: "phone_limit" }),
                                pattern: new RegExp(/^[0-9]+$/),
                              },
                            ]}
                            style={{
                              display: "inline-block",

                              width: "calc(47% - 8px)",
                              margin: "0px 0px 1px 0px ",
                            }}
                          >
                            <Input
                              type="number"
                              controls={true}
                              min={1}
                              onChange={(e) => {
                                form.setFieldsValue({
                                  [`contractexpirynumber`]: e.target.value,
                                });
                                dispatch(
                                  templateValueonChange({
                                    // item,
                                    parentindex,
                                    childindex,
                                    value: e.target.value,
                                    contractType: field?.contractType,
                                    // enddate: item.fields,
                                    field_id: field._id,
                                  })
                                );
                              }}
                              placeholder={formatMessage({
                                id: "enterdigit",
                              })}
                            />
                          </Form.Item>
                          <Form.Item
                            initialValue={
                              contentPreviewModaType === "createfromcontent" &&
                              field?.contractType
                            }
                            name="contractType"
                            rules={[
                              {
                                required: true,
                                message: "Please select Contract duration",
                              },
                            ]}
                            style={{
                              display: "inline-block",

                              width: "calc(48% - 8px)",
                              margin: "0px  0px 0px 15px ",
                            }}
                          >
                            <Select
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              optionFilterProp="children"
                              showSearch
                              showArrow
                              placeholder={formatMessage({ id: "select" })}
                              onChange={(value) =>
                                dispatch(
                                  templateValueonChange({
                                    parentindex,
                                    childindex,
                                    contractType: value,
                                    value: field.value,
                                    // enddate: item.fields,
                                    field_id: field._id,
                                  })
                                )
                              }
                            >
                              {selectexpirydata.map((rt, index) => (
                                <Option key={index} value={rt.value}>
                                  {formatMessage({ id: rt.name })}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </>
                    ) : (
                      <Form.Item
                        label={
                          <>
                            <span
                              className="label-h activityassets"
                              title={field.label}
                            >{`${
                              field?.translation?.[_locale]?.label ||
                              field?.translation?.en?.label ||
                              field.label
                            } `}</span>
                          </>
                        }
                        name={field.label}
                        {...formItemLayout}
                        initialValue={
                          contentPreviewModaType === "createfromcontent" &&
                          field.value
                            ? [7, 15].includes(field.dataType)
                              ? moment(field.value)
                              : field.value
                            : undefined
                        }
                        // hasFeedback
                        rules={
                          field.dataType === 8
                            ? [
                                {
                                  required: true,
                                  message: formatMessage({ id: "email_rule" }),
                                },
                                {
                                  type: "email",
                                  message: formatMessage({
                                    id: "email_valid_rule",
                                  }),
                                },
                              ]
                            : field.dataType === 9
                            ? [
                                {
                                  required: true,
                                  message: `Please enter ${
                                    field?.translation?.[_locale]?.label ||
                                    field?.translation?.en?.label ||
                                    field.label
                                  } `,
                                  pattern: new RegExp(/^[0-9]+$/),
                                },
                                {
                                  max: 14,
                                  min: 8,
                                  message: (
                                    <span style={{ textTransform: "none" }}>
                                      {`Phone no must be 8 - 14 digit long`}
                                    </span>
                                  ),
                                },
                              ]
                            : [
                                {
                                  required: true,
                                  message: `Please enter ${
                                    field?.translation?.[_locale]?.label ||
                                    field?.translation?.en?.label ||
                                    field.label
                                  } `,
                                },
                              ]
                        }
                      >
                        {(field.dataType === 0 && (
                          <Input
                            // onChange={(e)=>dispatch(Templatefilterdata({ ...Templatefiltereddata[parentindex]?.feilds[childindex],value:e.target.value}))
                            onChange={(e) =>
                              dispatch(
                                templateValueonChange({
                                  // item,
                                  parentindex,
                                  childindex,
                                  value: e.target.value,
                                  field_id: field._id,
                                })
                              )
                            }
                            placeholder={
                              field.placeholder ||
                              `${formatMessage({
                                id: "enter",
                              })} ${
                                field?.translation?.[_locale]?.label ||
                                field?.translation?.en?.label ||
                                field.label
                              }`
                            }
                            size="middle"
                            width={400}
                          />
                        )) ||
                          (field.dataType === 2 && (
                            <InputNumber
                              pattern="^\d+$"
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    // item,
                                    parentindex,
                                    childindex,
                                    value: e,
                                    field_id: field._id,
                                  })
                                )
                              }
                              placeholder={
                                field.placeholder ||
                                `${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`
                              }
                              controls={false}
                              size="middle"
                              width={"100%"}
                              style={{
                                width: "100%",
                              }}
                            />
                          )) ||
                          (field.dataType === 14 && (
                            <TextArea
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    // item,
                                    parentindex,
                                    childindex,
                                    value: e.target.value,
                                    field_id: field._id,
                                  })
                                )
                              }
                              placeholder={
                                field.placeholder ||
                                `${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`
                              }
                              controls={false}
                              size="middle"
                              width={"100%"}
                              style={{
                                width: "100%",
                              }}
                            />
                          )) ||
                          (field.dataType === 4 && (
                            <Upload
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    parentindex,
                                    childindex,
                                    value: e.file,
                                    field_id: field._id,
                                  })
                                )
                              }
                            >
                              <Button icon={<UploadOutlined />}>
                                Click to Upload
                              </Button>
                            </Upload>
                          )) ||
                          (field.dataType === 1 && (
                            <TextArea
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    parentindex,
                                    childindex,
                                    value: e.target.value,
                                    field_id: field._id,
                                  })
                                )
                              }
                              placeholder={
                                field.placeholder ||
                                `${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`
                              }
                              size="small"
                              width={200}
                            />
                          )) ||
                          (field.dataType === 12 && (
                            <InputNumber
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    // item,
                                    parentindex,
                                    childindex,
                                    value: e,
                                    field_id: field._id,
                                  })
                                )
                              }
                              placeholder={
                                field.placeholder ||
                                `${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`
                              }
                              controls={false}
                              size="middle"
                              width={"100%"}
                              style={{
                                width: "100%",
                              }}
                            />
                          )) ||
                          (field.dataType === 9 && (
                            <Input
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    // item,
                                    parentindex,
                                    childindex,
                                    value: e.target.value,
                                    field_id: field._id,
                                  })
                                )
                              }
                              // maxLength={10}
                              // minLength={10}
                              placeholder={
                                field.placeholder ||
                                `${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`
                              }
                              controls={false}
                              size="middle"
                              width={"100%"}
                              style={{
                                width: "100%",
                              }}
                            />
                          )) ||
                          (field.dataType === 10 && (
                            <>
                              <Editor
                                value={content1}
                                onChange={setContent}
                                // placeholder={pointn}
                              />
                            </>
                          )) ||
                          (field.dataType === 11 && (
                            <>
                              <SignatureCanvas
                                penColor="blue"
                                canvasProps={{
                                  style: {
                                    cursor: `url('/assets/images/pen-cursor.png'), auto`,
                                    border: "1px solid black",
                                    width: "100%",
                                    height: "150px",
                                  },

                                  className: "sigCanvas",
                                }}
                                ref={canvasRef}
                              />
                            </>
                          )) ||
                          ([7, 15].includes(field.dataType) &&
                            childindex === 0 && (
                              <DatePicker
                                disabledDate={(current) => {
                                  return (
                                    current && current < moment().startOf("day")
                                  );
                                }}
                                format="DD/MM/YYYY"
                                onChange={(date) =>
                                  dispatch(
                                    templateValueonChange({
                                      parentindex,
                                      childindex,
                                      value: date,
                                      field_id: field._id,
                                    })
                                  )
                                }
                                placeholder={`${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`}
                                style={{ width: "100%" }}
                              ></DatePicker>
                            )) ||
                          ([7, 15].includes(field.dataType) &&
                            childindex !== 0 && (
                              <DatePicker
                                onChange={(date) =>
                                  dispatch(
                                    templateValueonChange({
                                      parentindex,
                                      childindex,
                                      value: date,
                                      field_id: field._id,
                                    })
                                  )
                                }
                                format="DD/MM/YYYY"
                                placeholder={`${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`}
                                style={{ width: "100%" }}
                              ></DatePicker>
                            )) ||
                          (field.dataType === 8 && (
                            <Input
                              placeholder={
                                field.placeholder ||
                                `${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`
                              }
                              size="middle"
                              width={"100%"}
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    // item,
                                    parentindex,
                                    childindex,
                                    value: e.target.value,
                                    field_id: field._id,
                                  })
                                )
                              }
                            />
                          )) ||
                          (field.dataType === 3 && (
                            <Radio.Group
                              onChange={(e) =>
                                dispatch(
                                  templateValueonChange({
                                    parentindex,
                                    childindex,
                                    value: e.target.value,
                                    field_id: field._id,
                                  })
                                )
                              }
                            >
                              {field.options.map((item, index) => (
                                <Radio key={index} value={item}>
                                  {item}
                                </Radio>
                              ))}
                            </Radio.Group>
                          )) ||
                          (field.dataType === 5 && (
                            <Checkbox.Group
                              onChange={(checkedValues) =>
                                dispatch(
                                  templateValueonChange({
                                    parentindex,
                                    childindex,
                                    value: checkedValues,
                                    field_id: field._id,
                                  })
                                )
                              }
                            >
                              {field.options.map((item, index) => (
                                <Checkbox key={index} value={item}>
                                  {item}
                                </Checkbox>
                              ))}
                            </Checkbox.Group>
                          )) ||
                          (field.dataType === 6 &&
                            field.typeOfOptions === "Single" && (
                              <Select
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                                showArrow
                                optionFilterProp="children"
                                showSearch
                                onChange={(value) =>
                                  dispatch(
                                    templateValueonChange({
                                      parentindex,
                                      childindex,
                                      value: value,
                                      field_id: field._id,
                                    })
                                  )
                                }
                                placeholder={`${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`}
                              >
                                {field.options.map((item, index) => (
                                  <Option key={item} value={item}>
                                    {item}
                                  </Option>
                                ))}
                              </Select>
                            )) ||
                          (field.dataType === 6 &&
                            field.typeOfOptions === "Multiple" && (
                              <Select
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                                showArrow
                                optionFilterProp="children"
                                showSearch
                                onChange={(value) =>
                                  dispatch(
                                    templateValueonChange({
                                      parentindex,
                                      childindex,
                                      value: value,
                                      field_id: field._id,
                                    })
                                  )
                                }
                                mode="multiple"
                                allowClear
                                placeholder={`${formatMessage({
                                  id: "enter",
                                })} ${
                                  field?.translation?.[_locale]?.label ||
                                  field?.translation?.en?.label ||
                                  field.label
                                }`}
                              >
                                {field.options.map((item, index) => (
                                  <Option key={item} value={item}>
                                    {item}
                                  </Option>
                                ))}
                              </Select>
                            ))}
                      </Form.Item>
                    )}
                  </Col>
                  <Col span={1}></Col>
                  <Col span={1}>
                    <Tooltip
                      title={
                        field?.translation?.[_locale]?.description ||
                        field?.translation?.en?.description ||
                        field.info ||
                        `${formatMessage({
                          id: "enter",
                        })} ${
                          field?.translation?.[_locale]?.label ||
                          field?.translation?.en?.label ||
                          field.label ||
                          field.heading ||
                          field.date
                        }`
                      }
                    >
                      <InfoCircleOutlined
                        style={{
                          color: "#F99417",
                          fontSize: "15px",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </Col>
                </Row>
              ))}
          </CustomCard>
    
    </CustomCard>
  );
};

export default TemplateData;
